<template>
  <v-btn
    v-bind="$attrs"
    :color="color"
    :class="[{ 'spinner spinner-white spinner-right': loading }, btnClasses]"
    :disabled="!!loading"
    @click="handleClick"
    :type="type"
  >
    <slot name="label">
      <i v-if="icon" :class="[icon, iconClasses]"></i>
      {{ label }}
    </slot>
  </v-btn>
</template>

<script>
export default {
  inheritAttrs: false,
  name: 'base-inline-btn',

  props: {
    tag: {
      type: String,
      default: 'button',
      description: 'Button tag (default -> button)',
    },
    label: {
      type: String,
      description: 'btn label (text before btn)',
    },

    btnClasses: {
      type: String,
      description: 'btn  css classes',
    },
    iconClasses: {
      type: String,
      description: ' icon classes',
    },

    addonRightIcon: {
      type: String,
      description: 'Addon right icon',
    },
    icon: {
      type: String,
      description: ' left icon',
    },

    color: {
      type: String,
      description: 'btn color',
    },
    type: {
      type: String,
      description: 'btn type',
      default: 'submit',
    },
    loading: {
      type: [String, Boolean],
      default: false,
    },
  },
  data() {
    return {
      focused: false,
    };
  },
  computed: {},
  methods: {
    handleClick(evt) {
      this.$emit('click', evt);
    },
  },
};
</script>
<style scoped>
.v-btn {
  letter-spacing: 0;
}
</style>
